export default __webpack_public_path__ + "static/media/flag.ebbaa856.svg";